import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/services/auth.service';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
})
export class MainComponent {

	constructor(
		public authSrv: AuthService
	) {
		this.signIn();
	}

	signIn() {
		const unSubscribeAuth = this.authSrv.onAuthStateChanged((user) => {
			if (user) {
				unSubscribeAuth();
			} else {
				this.authSrv.signInAnonymously();
			}
		});
	}
}
